import React from "react";
import { Tag } from "antd";
import { getStatusConfig } from "../status/statusConfig";

const OrderStatusBadge = ({ status }) => {
  const config = getStatusConfig(status);
  return <Tag color={config.color}>{config.label}</Tag>;
};

export default OrderStatusBadge;
